<template>
  <HomeLayout>
    <!-- MOBILE strips -->
    <b-row
      v-if="fil === 'P'"
      class="home-nav-valid-quote-mobile d-block d-lg-none"
    >
      <b-col>
        <h6>This quote is valid until: {{ dueDate }}</h6>
      </b-col>
    </b-row>
    
    <b-row
      v-if="isUrgent && !isCancelled"
      class="home-nav-urgent-mobile d-block d-lg-none"
    >
      <b-col>
        <div @click.prevent="openContactUs">
          <h6>Contact Us</h6>
        </div>
      </b-col>
    </b-row>

    <b-row
      v-if="countdown && fil !== 'P'"
      class="home-nav-countdown-mobile d-block d-lg-none"
    >
      <b-col v-if="booking.booking_information.destination !== 'INS'">
        <div>
          <h6>Countdown to Departure:</h6>
          <p>{{ countdownClock }}</p>
        </div>
      </b-col>
    </b-row>

    <b-row
      v-if="feedback && fil !== 'P'"
      class="home-nav-feedback-mobile d-block d-lg-none"
    >
      <b-col>
        <div @click="showFeedbackModal">
          <h6>Click here to submit feedback on your experience</h6>
        </div>
      </b-col>
    </b-row>

    <b-row
      v-if="recentReturn"
      class="home-nav-urgent-mobile d-block d-lg-none"
    >
      <!-- // Post Travel Survey -->
      <b-col>
        <div @click.prevent="openModal(modalType)">
          <h6>Feedback and Comments</h6>
        </div>
      </b-col>
    </b-row>
    <!-- END of MOBILE -->

    <b-row
      v-if="fil === 'P'"
      class="d-none d-md-none d-lg-block"
    >
      <b-col
        class="home-nav-container-header-valid-quote"
      >
        <h6 class="d-none d-md-none d-lg-block m-0">
          This quote is valid until: {{ dueDate }}
        </h6>
      </b-col>
    </b-row>

    <b-row
      v-if="countdown && fil !== 'P'"
      class="d-none d-md-none d-lg-block"
    >
      <b-col
        v-if="booking.booking_information.destination !== 'INS'"
        class="home-nav-container-header-countdown"
      >
        <div class="countdown-msg d-none d-md-none d-lg-block">
          <h6 class="m-0">
            Countdown to Departure:
          </h6>
          <p class="m-0">
            {{ countdownClock }}
          </p>
        </div>
      </b-col>
    </b-row>

    <b-row
      v-if="isUrgent && !isCancelled"
      class="d-none d-md-none d-lg-block"
    >
      <b-col
        class="home-nav-container-header-urgent"
        @click.prevent="openContactUs"
      >
        <div class="countdown-msg d-none d-md-none d-lg-block">
          <h6>Contact Us</h6>
        </div>
      </b-col>
    </b-row>

    <b-row
      v-if="feedback && fil !== 'P'"
      class="d-none d-md-none d-lg-flex feedback-row"
    >
      <b-col
        class="home-nav-container-header-feedback d-flex p-0"
        @click="showFeedbackModal"
      >
        <div class="feedback-msg d-none d-md-none d-lg-flex p-0">
          <h6 class="m-0">
            Click here to submit feedback on your experience
          </h6>
        </div>
      </b-col>
    </b-row>

    <b-row
      v-if="recentReturn"
      class="d-none d-md-none d-lg-block"
    >
      <!-- // Post Travel Survey -->
      <b-col
        class="home-nav-container-header-urgent"
        @click.prevent="openModal(modalType)"
      >
        <div class="countdown-msg d-none d-md-none d-lg-block">
          <h6>Feedback and Comments</h6>
        </div>
      </b-col>
    </b-row>


    <!-- ///// DYNAMIC PANELS -->
    <b-row
      v-if="booking"
      class="column-border-container"
    >
      <b-col class="column-border col-lg card-col col-12">
        <router-link
          :to="{
            name: 'booking',
            params: {
              itineraryPage: 'Itinerary',
            },
          }"
          class="vtd-card vtd-animate-shake"
        >
          <div class="navigation-block">
            <h4 class="nav-title-center">
              YOUR ITINERARY
            </h4>
            <div class="nav-text-center">
              <i class="icon-itinerary vtd-icon-7" />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">
              View Now
            </p>
          </div>
        </router-link>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <router-link
          :to="
            fil === 'P'
              ? {
                name: 'payment-hub-landing',
                params: {
                  paymentConditions: 'Payment Hub',
                },
              }
              : {
                name: 'trip-hub-landing',
                params: {
                  tripHub: 'Trip Hub',
                },
              }
          "
          class="vtd-card vtd-animate-shake"
        >
          <div class="navigation-block">
            <div
              v-if="fil === 'P'"
              class="nav-text-center d-flex flex-column p-0"
            >
              <h4 class="nav-title-center">
                CONFIRM
              </h4>
              <h6 class="confirm-sub-text">
                Booking Terms &amp; Conditions
              </h6>
            </div>
            <h4
              v-if="fil === 'M'"
              class="nav-title-center"
            >
              TRIP HUB
            </h4>
            <div class="nav-text-center">
              <i
                v-if="fil === 'P'"
                class="icon-payment vtd-icon-7"
              />
              <i
                v-else
                class="icon-trip_hub vtd-icon-7"
              />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">
              View Now
            </p>
          </div>
        </router-link>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <div
          v-if="fil === 'P'"
          class="vtd-card vtd-animate-shake"
          @click="openGoodReasonsModal"
        >
          <div class="navigation-block">
            <h4 class="nav-title-center">
              GOOD REASONS TO CHOOSE TRAILFINDERS
            </h4>
            <div class="nav-text-center">
              <i class="icon-tf_difference vtd-icon-7" />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">
              View Now
            </p>
          </div>
        </div>

        <router-link
          v-else
          :to="{
            name: 'vouchers-documents-landing',
            params: {
              voucherDocs: 'Vouchers & Documents',
            },
          }"
          class="vtd-card vtd-animate-shake"
        >
          <div class="navigation-block">
            <h4 class="nav-title-center">
              VOUCHERS &amp; DOCUMENTS
            </h4>
            <div class="nav-text-center">
              <i class="icon-vouchers_and_documents vtd-icon-7" />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">
              View Now
            </p>
          </div>
        </router-link>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <router-link
          :to="
            fil === 'P'
              ? {
                name: 'trip-hub-landing',
                params: {
                  tripHub: 'Trip Hub',
                },
              }
              : {
                name: 'payment-hub-landing',
                params: {
                  paymentConditions: 'Payment Hub',
                },
              }
          "
          class="vtd-card vtd-animate-shake"
        >
          <div class="navigation-block">
            <h4
              v-if="fil === 'P'"
              class="nav-title-center"
            >
              TRIP HUB
            </h4>
            <h4
              v-if="fil === 'M'"
              class="nav-title-center"
            >
              PAYMENT HUB
            </h4>
            <div class="nav-text-center">
              <i
                v-if="fil === 'P'"
                class="icon-trip_hub vtd-icon-7"
              />
              <i
                v-else
                class="icon-payment vtd-icon-7"
              />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">
              View Now
            </p>
          </div>
        </router-link>
      </b-col>

      <b-col v-if="fil !== 'P' && !isCancelled && destination !== 'INS'" class="column-border col-lg card-col col-12">
        <router-link
          :to="
            {
                name: 'communications'
              }
          "
          class="vtd-card vtd-animate-shake"
        >
          <div class="navigation-block">
            <h4
              class="nav-title-center"
            >
              COMMUNICATIONS
            </h4>
            <div class="nav-text-center">
              <span style="position: relative; display: inline-flex; align-items: center; justify-content: center;">
                <i
                  class="icon-email_share vtd-icon-7"
                />
                <span
                  v-if="hasUnreadCurrentEtrails"
                  style="position: absolute; top: 0; right: -8px; width: 12px; height: 12px; background: #e53e3e; border-radius: 50%; display: block;"
                  title="Unread messages"
                />
              </span>
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">
              View Now
            </p>
          </div>
        </router-link>
      </b-col>
    </b-row>

    <GoodReasonsModal ref="GoodReasons" />
    <UrgencyPicker
      ref="UrgencyPickerRef"
      @selected="onUrgencySelected"
    />
    <Etrail
      ref="EtrailRef"
      :booking="booking"
      :contact-mode="contactMode"
      source="urgAssistance"
    />
    <PostTravelSurvey
      v-if="booking"
      ref="PostTravelSurveyRef"
      :booking="booking"
    />
    <Contact ref="ContactRef" />
    <AssistanceProv ref="AssistanceProvRef" />
    <Feedback
      v-if="booking && booking.user_information"
      ref="FeedbackRef"
      :email="booking.user_information.email"
    />
  </HomeLayout>
</template>

<script>

import { mapActions, mapGetters } from "vuex";
import dayjs from '@/lib/dayjs';
import HomeLayout from "@/partials/home-layout";
import AssistanceProv from "@/modules/home/assistance-prov/Index.vue";
import {
  getPanelType,
  checkIfFlightAfterNow,
  generateCountDownTimerString,
} from "./home.module";
import {
  isUrgentCheck,
  isHomeCheck,
} from "@/partials/contact-us/contact-us.module.js";
import Etrail from "@/partials/contact-us/etrail/index.vue";
import UrgencyPicker from "@/partials/contact-us/urgency-picker/index.vue";
import PostTravelSurvey from "@/partials/contact-us/post-travel-survey/index.vue";
import Contact from "@/partials/contact-us/contact/index.vue";
import Feedback from "@/modules/booking/feedback";
import GoodReasonsModal from "@/modules/navigation/modals/good-reasons"
import { getTrustPilotURL } from "@/modules/booking/services.js"

export default {
  components: {
    HomeLayout,
    Etrail,
    UrgencyPicker,
    Contact,
    AssistanceProv,
    Feedback,
    PostTravelSurvey,
    GoodReasonsModal
  },
  data() {
    return {
      isHome: false,
      modalType: "EtrailRef",
      contactMode: "pre-travel",
      countdown: false,
      countdownClock: null,
      countdownTimer: null,
      contactText: "CONTACT US",
      etrail: false,
      feedback: false,
      recentReturn: false,
    };
  },
  computed: {
    ...mapGetters({
      booking: "booking/getBooking",
      dueDate: "booking/getDueDate",
      departureDate: "booking/getDeptDate",
      fil: "booking/getFil",
      firstFlightItineraryItem: "booking/getFirstFlightItineraryItem",
      destination: "booking/getDestination",
      tripHasStarted: "booking/getTripStarted",
      tripHasEnded: "booking/getTripEnded",
      userData: "auth/getUserData",
      userType: "auth/getUserType",
      friendFamily: "friendFamily/isFriendFamily",
      paxNames: "booking/getBookingPassengers",
      isCancelled: "booking/isBookingCancelled",
      currentEtrails: "communications/getCurrentEtrails"
    }),
    // Same unread check as the Communications page's own "CURRENT
    // COMMUNICATIONS" tile — currentEtrails is already loaded app-wide on
    // init (communications/setEtrailsAction), so no extra fetch is needed
    // here to know whether the homepage tile should show a badge too.
    hasUnreadCurrentEtrails() {
      return (this.currentEtrails || []).some((etrail) =>
        (etrail.messages || []).some((msg) => !msg.client && !msg.read)
      )
    },

    getPanelType() {
      if (this.booking) {
        return getPanelType(
          this.booking.booking_itinerary,
          this.booking.booking_information
        );
      }
      return null;
    },
    isUrgent() {
      if (this.booking) {
        return isUrgentCheck(this.booking, this.departureDate);
      }
      return null;
    },
  },
  watch: {
    tripHasEnded(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.isRecentReturn();
        this.isHomeCheckMethod();
      }
    },
    departureDate() {
      this.countDownTimer(this.booking.booking_information)
    }
  },
  async created() {
    this.isRecentReturn();
    this.isHomeCheckMethod();
    if (!this.friendFamily && this.userType === "corporate") {
      this.$router.push("/landing-corp");
      return;
    }
    const loginRes = await this.loginOnStart({
      username: this.$route.params.surname,
      bookingNumber: this.$route.params.bookingNumber,
      source: this.$route.params.source,
    });
    this.$emit("loading-bar", false);
    if (!loginRes) {
      this.$router.push("/login");
      return;
    }
    if (this.$route.name === "commsauthsource") {
      this.$router.push({ name: "communications" });
      return;
    }
    if (this.booking && this.booking.booking_information) {
      this.countDownTimer(this.booking.booking_information);
    }
    if (this.fil === "M" && !this.isUrgent) {
      if (
        !this.tripHasEnded &&
        !this.friendFamily &&
        this.destination !== "INS"
      ) {
        this.etrail = true;
      } else if (this.destination !== "INS" && !this.tripHasStarted) {
        this.etrail = true;
      }
    }
    if (this.$route.query.trip_hub) {
      this.$router.push('/trip-hub')
    }
    if (this.$route.query.payment_hub) {
      this.$router.push('/payment-hub')
    }
  },
  updated() {
    // needs time to get data from store else countdown disappears
    // if (this.booking.booking_information) {
    //   this.countDownTimer(this.booking.booking_information, this);
    // }
    if (
      (this.fil === "P" && this.booking.feedback_exists !== true) ||
      (this.booking && this.booking.numDaysSinceAuth <= 10 &&
        this.booking.feedback_exists !== true)
    ) {
      this.feedback = true;
    }
  },
  beforeDestroy() {
    // here need to clear all listeners to avoid memory leaks
    clearInterval(this.countdownTimer);
  },
  methods: {
    ...mapActions({
      loginOnStart: "auth/loginBookingNumberOnStartAction",
    }),
    isRecentReturn() {
      // if the return date is within a 28-day window from today
      if (this.tripHasEnded) {
        const now = dayjs(new Date());
        const twentyEightDaysAgo = now.subtract(28, "days");
        const returnDate = dayjs(
          this.booking.booking_information.vtdate_return
        );
        if (returnDate.isAfter(twentyEightDaysAgo)) this.recentReturn = true;
      } else {
        this.recentReturn = false;
      }
    },
    openContactUs() {
      this.$refs["UrgencyPickerRef"].show();
    },
    onUrgencySelected(mode) {
      this.contactMode = mode;
      this.$refs["EtrailRef"].show();
    },
    openModal(item) {
      if (
        item === "ContactRef" ||
        item === "EtrailRef" ||
        item === "PostTravelSurveyRef"
      ) {
        this.$refs[item].show();
      } else {
        this.$refs[item].showModal();
      }
    },
    openGoodReasonsModal() {
      this.$refs['GoodReasons'].showModal();
    },
    isHomeCheckMethod() {
      if (this.booking && isHomeCheck(this.booking) && this.recentReturn) {
        // Every recently returned booking gets the one survey; which sections it
        // contains (tours, Communications & Information) is decided by the API.
        this.modalType = "PostTravelSurveyRef";
        return true;
      } else if (
        this.booking &&
        isHomeCheck(this.booking) &&
        !this.recentReturn
      ) {
        this.modalType = "ContactRef";
        return true;
      }
      this.modalType = "EtrailRef";
      return false;
    },
    countDownTimer(item) {
      if (checkIfFlightAfterNow(item)) {
        // initial render
        this.countdown = true;
        this.countdownClock = generateCountDownTimerString(this.departureDate);
        this.countdownTimer = setInterval(() => {
          this.countdown = true;
          this.countdownClock = generateCountDownTimerString(this.departureDate);
          if (!this.countdownClock) {
            this.countdown = false;
            clearInterval(this.countdownTimer);
          }
        }, 60000); // 1 minute step
      }
    },
    async showFeedbackModal() {
      const tpurl = await getTrustPilotURL(this.booking.user_information.bookingNumber, this.paxNames[0])
      if(tpurl) this.$refs.FeedbackRef.showModal(tpurl);
    }
  },
};
</script>

<style lang="scss">
@import "./styles.scss";
</style>
